// Generated from ./src/core/antlr/LambdaCalc.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {
	ATN,
	ATNDeserializer, DecisionState, DFA, FailedPredicateException,
	RecognitionException, NoViableAltException, BailErrorStrategy,
	Parser, ParserATNSimulator,
	RuleContext, ParserRuleContext, PredictionMode, PredictionContextCache,
	TerminalNode, RuleNode,
	Token, TokenStream,
	Interval, IntervalSet
} from 'antlr4';
import LambdaCalcListener from "./LambdaCalcListener.js";
import LambdaCalcVisitor from "./LambdaCalcVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;

export default class LambdaCalcParser extends Parser {
	public static readonly T__0 = 1;
	public static readonly T__1 = 2;
	public static readonly T__2 = 3;
	public static readonly T__3 = 4;
	public static readonly T__4 = 5;
	public static readonly T__5 = 6;
	public static readonly T__6 = 7;
	public static readonly T__7 = 8;
	public static readonly T__8 = 9;
	public static readonly T__9 = 10;
	public static readonly T__10 = 11;
	public static readonly T__11 = 12;
	public static readonly T__12 = 13;
	public static readonly T__13 = 14;
	public static readonly T__14 = 15;
	public static readonly T__15 = 16;
	public static readonly T__16 = 17;
	public static readonly T__17 = 18;
	public static readonly T__18 = 19;
	public static readonly T__19 = 20;
	public static readonly T__20 = 21;
	public static readonly T__21 = 22;
	public static readonly T__22 = 23;
	public static readonly T__23 = 24;
	public static readonly T__24 = 25;
	public static readonly T__25 = 26;
	public static readonly T__26 = 27;
	public static readonly T__27 = 28;
	public static readonly T__28 = 29;
	public static readonly T__29 = 30;
	public static readonly T__30 = 31;
	public static readonly T__31 = 32;
	public static readonly LAMBDA = 33;
	public static readonly EQ = 34;
	public static readonly NIL = 35;
	public static readonly CONS = 36;
	public static readonly ISNIL = 37;
	public static readonly TAIL = 38;
	public static readonly HEAD = 39;
	public static readonly LBRACK = 40;
	public static readonly RBRACK = 41;
	public static readonly ID = 42;
	public static readonly GREEK_TYPE = 43;
	public static readonly NATURAL_NUMBER = 44;
	public static readonly COMMA = 45;
	public static readonly ARROW = 46;
	public static readonly DOUBLEARROW = 47;
	public static readonly COLON = 48;
	public static readonly DOT = 49;
	public static readonly SEMI = 50;
	public static readonly LPAREN = 51;
	public static readonly RPAREN = 52;
	public static readonly LINE_COMMENT = 53;
	public static readonly WS = 54;
	public static override readonly EOF = Token.EOF;
	public static readonly RULE_expression = 0;
	public static readonly RULE_terms = 1;
	public static readonly RULE_globalDecl = 2;
	public static readonly RULE_term = 3;
	public static readonly RULE_type = 4;
	public static readonly RULE_list_op = 5;
	public static readonly RULE_constant = 6;
	public static readonly literalNames: (string | null)[] = [ null, "'typedef'", 
                                                            "'>'", "'>='", 
                                                            "'<'", "'<='", 
                                                            "'=='", "'+'", 
                                                            "'-'", "'*'", 
                                                            "'^'", "'_'", 
                                                            "'if'", "'then'", 
                                                            "'else if'", 
                                                            "'else'", "'fix'", 
                                                            "'as'", "'inl'", 
                                                            "'inr'", "'case'", 
                                                            "'of'", "'||'", 
                                                            "'Nat'", "'Bool'", 
                                                            "'Unit'", "'List '", 
                                                            "'0'", "'true'", 
                                                            "'True'", "'false'", 
                                                            "'False'", "'unit'", 
                                                            null, "'='", 
                                                            "'nil'", "'cons'", 
                                                            "'isnil'", "'tail'", 
                                                            "'head'", "'['", 
                                                            "']'", null, 
                                                            null, null, 
                                                            "','", null, 
                                                            null, "':'", 
                                                            "'.'", "';'", 
                                                            "'('", "')'" ];
	public static readonly symbolicNames: (string | null)[] = [ null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, "LAMBDA", 
                                                             "EQ", "NIL", 
                                                             "CONS", "ISNIL", 
                                                             "TAIL", "HEAD", 
                                                             "LBRACK", "RBRACK", 
                                                             "ID", "GREEK_TYPE", 
                                                             "NATURAL_NUMBER", 
                                                             "COMMA", "ARROW", 
                                                             "DOUBLEARROW", 
                                                             "COLON", "DOT", 
                                                             "SEMI", "LPAREN", 
                                                             "RPAREN", "LINE_COMMENT", 
                                                             "WS" ];
	// tslint:disable:no-trailing-whitespace
	public static readonly ruleNames: string[] = [
		"expression", "terms", "globalDecl", "term", "type", "list_op", "constant",
	];
	public get grammarFileName(): string { return "LambdaCalc.g4"; }
	public get literalNames(): (string | null)[] { return LambdaCalcParser.literalNames; }
	public get symbolicNames(): (string | null)[] { return LambdaCalcParser.symbolicNames; }
	public get ruleNames(): string[] { return LambdaCalcParser.ruleNames; }
	public get serializedATN(): number[] { return LambdaCalcParser._serializedATN; }

	protected createFailedPredicateException(predicate?: string, message?: string): FailedPredicateException {
		return new FailedPredicateException(this, predicate, message);
	}

	constructor(input: TokenStream) {
		super(input);
		this._interp = new ParserATNSimulator(this, LambdaCalcParser._ATN, LambdaCalcParser.DecisionsToDFA, new PredictionContextCache());
	}
	// @RuleVersion(0)
	public expression(): ExpressionContext {
		let localctx: ExpressionContext = new ExpressionContext(this, this._ctx, this.state);
		this.enterRule(localctx, 0, LambdaCalcParser.RULE_expression);
		try {
			let _alt: number;
			localctx = new ExprContext(this, localctx);
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 17;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 0, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					{
					{
					this.state = 14;
					this.globalDecl();
					}
					}
				}
				this.state = 19;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 0, this._ctx);
			}
			this.state = 20;
			this.terms();
			this.state = 21;
			this.match(LambdaCalcParser.EOF);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public terms(): TermsContext {
		let localctx: TermsContext = new TermsContext(this, this._ctx, this.state);
		this.enterRule(localctx, 2, LambdaCalcParser.RULE_terms);
		let _la: number;
		try {
			let _alt: number;
			localctx = new SequenceContext(this, localctx);
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 28;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 1, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					{
					{
					this.state = 23;
					(localctx as SequenceContext)._seqTerm = this.term(0);
					this.state = 24;
					this.match(LambdaCalcParser.SEMI);
					}
					}
				}
				this.state = 30;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 1, this._ctx);
			}
			this.state = 31;
			(localctx as SequenceContext)._seqTerm = this.term(0);
			this.state = 32;
			this.match(LambdaCalcParser.COLON);
			this.state = 33;
			this.type_(0);
			this.state = 35;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if (_la===50) {
				{
				this.state = 34;
				this.match(LambdaCalcParser.SEMI);
				}
			}

			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public globalDecl(): GlobalDeclContext {
		let localctx: GlobalDeclContext = new GlobalDeclContext(this, this._ctx, this.state);
		this.enterRule(localctx, 4, LambdaCalcParser.RULE_globalDecl);
		let _la: number;
		try {
			this.state = 57;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 4, this._ctx) ) {
			case 1:
				localctx = new TypeAliasContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 37;
				this.match(LambdaCalcParser.T__0);
				this.state = 38;
				this.match(LambdaCalcParser.ID);
				this.state = 39;
				this.match(LambdaCalcParser.EQ);
				this.state = 40;
				this.type_(0);
				this.state = 41;
				this.match(LambdaCalcParser.SEMI);
				}
				break;
			case 2:
				localctx = new GlobalVariableDeclarationContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 43;
				this.match(LambdaCalcParser.ID);
				this.state = 44;
				this.match(LambdaCalcParser.COLON);
				this.state = 45;
				this.type_(0);
				this.state = 46;
				this.match(LambdaCalcParser.SEMI);
				}
				break;
			case 3:
				localctx = new GlobalFunctionDeclarationContext(this, localctx);
				this.enterOuterAlt(localctx, 3);
				{
				this.state = 48;
				this.match(LambdaCalcParser.ID);
				this.state = 49;
				this.match(LambdaCalcParser.EQ);
				this.state = 50;
				this.term(0);
				this.state = 53;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (_la===48) {
					{
					this.state = 51;
					this.match(LambdaCalcParser.COLON);
					this.state = 52;
					this.type_(0);
					}
				}

				this.state = 55;
				this.match(LambdaCalcParser.SEMI);
				}
				break;
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public term(): TermContext;
	public term(_p: number): TermContext;
	// @RuleVersion(0)
	public term(_p?: number): TermContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let localctx: TermContext = new TermContext(this, this._ctx, _parentState);
		let _prevctx: TermContext = localctx;
		let _startState: number = 6;
		this.enterRecursionRule(localctx, 6, LambdaCalcParser.RULE_term, _p);
		let _la: number;
		try {
			let _alt: number;
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 176;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 10, this._ctx) ) {
			case 1:
				{
				localctx = new LambdaAbstractionContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;

				this.state = 60;
				this.match(LambdaCalcParser.LAMBDA);
				this.state = 61;
				this.match(LambdaCalcParser.ID);
				this.state = 62;
				this.match(LambdaCalcParser.COLON);
				this.state = 63;
				this.type_(0);
				this.state = 64;
				this.match(LambdaCalcParser.DOT);
				this.state = 65;
				this.term(16);
				}
				break;
			case 2:
				{
				localctx = new WildCardContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 67;
				this.match(LambdaCalcParser.LAMBDA);
				this.state = 68;
				this.match(LambdaCalcParser.T__10);
				this.state = 69;
				this.match(LambdaCalcParser.COLON);
				this.state = 70;
				this.type_(0);
				this.state = 71;
				this.match(LambdaCalcParser.DOT);
				this.state = 72;
				this.term(15);
				}
				break;
			case 3:
				{
				localctx = new IfElseContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 74;
				this.match(LambdaCalcParser.T__11);
				this.state = 75;
				this.term(0);
				this.state = 76;
				this.match(LambdaCalcParser.T__12);
				this.state = 77;
				this.term(0);
				this.state = 85;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 5, this._ctx);
				while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
					if (_alt === 1) {
						{
						{
						this.state = 78;
						this.match(LambdaCalcParser.T__13);
						this.state = 79;
						this.term(0);
						this.state = 80;
						this.match(LambdaCalcParser.T__12);
						this.state = 81;
						this.term(0);
						}
						}
					}
					this.state = 87;
					this._errHandler.sync(this);
					_alt = this._interp.adaptivePredict(this._input, 5, this._ctx);
				}
				this.state = 90;
				this._errHandler.sync(this);
				switch ( this._interp.adaptivePredict(this._input, 6, this._ctx) ) {
				case 1:
					{
					this.state = 88;
					this.match(LambdaCalcParser.T__14);
					this.state = 89;
					this.term(0);
					}
					break;
				}
				}
				break;
			case 4:
				{
				localctx = new VariableContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 92;
				this.match(LambdaCalcParser.ID);
				}
				break;
			case 5:
				{
				localctx = new FixContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 93;
				this.match(LambdaCalcParser.T__15);
				this.state = 94;
				this.term(12);
				}
				break;
			case 6:
				{
				localctx = new LiteralContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 95;
				this.constant();
				}
				break;
			case 7:
				{
				localctx = new InjectionContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 96;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 97;
				this.match(LambdaCalcParser.ID);
				this.state = 98;
				this.match(LambdaCalcParser.EQ);
				this.state = 99;
				this.term(0);
				this.state = 100;
				this.match(LambdaCalcParser.RBRACK);
				this.state = 101;
				this.match(LambdaCalcParser.T__16);
				this.state = 102;
				this.type_(0);
				}
				break;
			case 8:
				{
				localctx = new LeftRightInjContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 104;
				_la = this._input.LA(1);
				if(!(_la===18 || _la===19)) {
				this._errHandler.recoverInline(this);
				}
				else {
					this._errHandler.reportMatch(this);
				    this.consume();
				}
				this.state = 105;
				this.term(0);
				this.state = 106;
				this.match(LambdaCalcParser.T__16);
				this.state = 107;
				this.type_(0);
				}
				break;
			case 9:
				{
				localctx = new RecordContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 109;
				this.match(LambdaCalcParser.T__3);
				this.state = 110;
				this.match(LambdaCalcParser.ID);
				this.state = 111;
				this.match(LambdaCalcParser.EQ);
				this.state = 112;
				this.term(0);
				this.state = 119;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				while (_la===45) {
					{
					{
					this.state = 113;
					this.match(LambdaCalcParser.COMMA);
					this.state = 114;
					this.match(LambdaCalcParser.ID);
					this.state = 115;
					this.match(LambdaCalcParser.EQ);
					this.state = 116;
					this.term(0);
					}
					}
					this.state = 121;
					this._errHandler.sync(this);
					_la = this._input.LA(1);
				}
				this.state = 122;
				this.match(LambdaCalcParser.T__1);
				}
				break;
			case 10:
				{
				localctx = new TupleContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 124;
				this.match(LambdaCalcParser.T__3);
				this.state = 125;
				this.term(0);
				this.state = 130;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				while (_la===45) {
					{
					{
					this.state = 126;
					this.match(LambdaCalcParser.COMMA);
					this.state = 127;
					this.term(0);
					}
					}
					this.state = 132;
					this._errHandler.sync(this);
					_la = this._input.LA(1);
				}
				this.state = 133;
				this.match(LambdaCalcParser.T__1);
				}
				break;
			case 11:
				{
				localctx = new ListContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 135;
				this.list_op();
				}
				break;
			case 12:
				{
				localctx = new CaseOfContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 136;
				this.match(LambdaCalcParser.T__19);
				this.state = 137;
				this.term(0);
				this.state = 138;
				this.match(LambdaCalcParser.T__20);
				this.state = 139;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 140;
				this.match(LambdaCalcParser.ID);
				this.state = 141;
				this.match(LambdaCalcParser.EQ);
				this.state = 142;
				this.match(LambdaCalcParser.ID);
				this.state = 143;
				this.match(LambdaCalcParser.RBRACK);
				this.state = 144;
				this.match(LambdaCalcParser.DOUBLEARROW);
				this.state = 145;
				this.term(0);
				this.state = 156;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 9, this._ctx);
				while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
					if (_alt === 1) {
						{
						{
						this.state = 146;
						this.match(LambdaCalcParser.T__21);
						this.state = 147;
						this.match(LambdaCalcParser.LBRACK);
						this.state = 148;
						this.match(LambdaCalcParser.ID);
						this.state = 149;
						this.match(LambdaCalcParser.EQ);
						this.state = 150;
						this.match(LambdaCalcParser.ID);
						this.state = 151;
						this.match(LambdaCalcParser.RBRACK);
						this.state = 152;
						this.match(LambdaCalcParser.DOUBLEARROW);
						this.state = 153;
						this.term(0);
						}
						}
					}
					this.state = 158;
					this._errHandler.sync(this);
					_alt = this._interp.adaptivePredict(this._input, 9, this._ctx);
				}
				}
				break;
			case 13:
				{
				localctx = new BinaryCaseOfContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 159;
				this.match(LambdaCalcParser.T__19);
				this.state = 160;
				this.term(0);
				this.state = 161;
				this.match(LambdaCalcParser.T__20);
				this.state = 162;
				_la = this._input.LA(1);
				if(!(_la===18 || _la===19)) {
				this._errHandler.recoverInline(this);
				}
				else {
					this._errHandler.reportMatch(this);
				    this.consume();
				}
				this.state = 163;
				this.match(LambdaCalcParser.ID);
				this.state = 164;
				this.match(LambdaCalcParser.DOUBLEARROW);
				this.state = 165;
				this.term(0);
				this.state = 166;
				this.match(LambdaCalcParser.T__21);
				this.state = 167;
				_la = this._input.LA(1);
				if(!(_la===18 || _la===19)) {
				this._errHandler.recoverInline(this);
				}
				else {
					this._errHandler.reportMatch(this);
				    this.consume();
				}
				this.state = 168;
				this.match(LambdaCalcParser.ID);
				this.state = 169;
				this.match(LambdaCalcParser.DOUBLEARROW);
				this.state = 170;
				this.term(2);
				}
				break;
			case 14:
				{
				localctx = new ParenthesesContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 172;
				this.match(LambdaCalcParser.LPAREN);
				this.state = 173;
				this.term(0);
				this.state = 174;
				this.match(LambdaCalcParser.RPAREN);
				}
				break;
			}
			this._ctx.stop = this._input.LT(-1);
			this.state = 200;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 12, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = localctx;
					{
					this.state = 198;
					this._errHandler.sync(this);
					switch ( this._interp.adaptivePredict(this._input, 11, this._ctx) ) {
					case 1:
						{
						localctx = new ApplicationContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 178;
						if (!(this.precpred(this._ctx, 21))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 21)");
						}
						this.state = 179;
						this.term(22);
						}
						break;
					case 2:
						{
						localctx = new ComparisonContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 180;
						if (!(this.precpred(this._ctx, 20))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 20)");
						}
						this.state = 181;
						_la = this._input.LA(1);
						if(!((((_la) & ~0x1F) === 0 && ((1 << _la) & 124) !== 0))) {
						this._errHandler.recoverInline(this);
						}
						else {
							this._errHandler.reportMatch(this);
						    this.consume();
						}
						this.state = 182;
						this.term(21);
						}
						break;
					case 3:
						{
						localctx = new AdditionContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 183;
						if (!(this.precpred(this._ctx, 19))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 19)");
						}
						this.state = 184;
						_la = this._input.LA(1);
						if(!(_la===7 || _la===8)) {
						this._errHandler.recoverInline(this);
						}
						else {
							this._errHandler.reportMatch(this);
						    this.consume();
						}
						this.state = 185;
						this.term(20);
						}
						break;
					case 4:
						{
						localctx = new MultiplicationContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 186;
						if (!(this.precpred(this._ctx, 18))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 18)");
						}
						{
						this.state = 187;
						this.match(LambdaCalcParser.T__8);
						}
						this.state = 188;
						this.term(19);
						}
						break;
					case 5:
						{
						localctx = new PowerContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 189;
						if (!(this.precpred(this._ctx, 17))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 17)");
						}
						{
						this.state = 190;
						this.match(LambdaCalcParser.T__9);
						}
						this.state = 191;
						this.term(18);
						}
						break;
					case 6:
						{
						localctx = new RecordProjectionContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 192;
						if (!(this.precpred(this._ctx, 6))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 6)");
						}
						this.state = 193;
						this.match(LambdaCalcParser.DOT);
						this.state = 194;
						this.match(LambdaCalcParser.ID);
						}
						break;
					case 7:
						{
						localctx = new TupleProjectionContext(this, new TermContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_term);
						this.state = 195;
						if (!(this.precpred(this._ctx, 5))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 5)");
						}
						this.state = 196;
						this.match(LambdaCalcParser.DOT);
						this.state = 197;
						this.match(LambdaCalcParser.NATURAL_NUMBER);
						}
						break;
					}
					}
				}
				this.state = 202;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 12, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return localctx;
	}

	public type_(): TypeContext;
	public type_(_p: number): TypeContext;
	// @RuleVersion(0)
	public type_(_p?: number): TypeContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let localctx: TypeContext = new TypeContext(this, this._ctx, _parentState);
		let _prevctx: TypeContext = localctx;
		let _startState: number = 8;
		this.enterRecursionRule(localctx, 8, LambdaCalcParser.RULE_type, _p);
		let _la: number;
		try {
			let _alt: number;
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 241;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 23:
			case 24:
			case 25:
			case 42:
			case 43:
				{
				localctx = new GreekTypeContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;

				this.state = 204;
				_la = this._input.LA(1);
				if(!(((((_la - 23)) & ~0x1F) === 0 && ((1 << (_la - 23)) & 1572871) !== 0))) {
				this._errHandler.recoverInline(this);
				}
				else {
					this._errHandler.reportMatch(this);
				    this.consume();
				}
				}
				break;
			case 26:
				{
				localctx = new ListTypeContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 205;
				this.match(LambdaCalcParser.T__25);
				this.state = 206;
				this.type_(7);
				}
				break;
			case 4:
				{
				localctx = new RecordTypeContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 207;
				this.match(LambdaCalcParser.T__3);
				this.state = 208;
				this.match(LambdaCalcParser.ID);
				this.state = 209;
				this.match(LambdaCalcParser.COLON);
				this.state = 210;
				this.type_(0);
				this.state = 217;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				while (_la===45) {
					{
					{
					this.state = 211;
					this.match(LambdaCalcParser.COMMA);
					this.state = 212;
					this.match(LambdaCalcParser.ID);
					this.state = 213;
					this.match(LambdaCalcParser.COLON);
					this.state = 214;
					this.type_(0);
					}
					}
					this.state = 219;
					this._errHandler.sync(this);
					_la = this._input.LA(1);
				}
				this.state = 220;
				this.match(LambdaCalcParser.T__1);
				}
				break;
			case 40:
				{
				localctx = new VariantTypeContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 222;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 223;
				this.match(LambdaCalcParser.ID);
				this.state = 224;
				this.match(LambdaCalcParser.COLON);
				this.state = 225;
				this.type_(0);
				this.state = 232;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				while (_la===45) {
					{
					{
					this.state = 226;
					this.match(LambdaCalcParser.COMMA);
					this.state = 227;
					this.match(LambdaCalcParser.ID);
					this.state = 228;
					this.match(LambdaCalcParser.COLON);
					this.state = 229;
					this.type_(0);
					}
					}
					this.state = 234;
					this._errHandler.sync(this);
					_la = this._input.LA(1);
				}
				this.state = 235;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			case 51:
				{
				localctx = new ParenTypeContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 237;
				this.match(LambdaCalcParser.LPAREN);
				this.state = 238;
				this.type_(0);
				this.state = 239;
				this.match(LambdaCalcParser.RPAREN);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
			this._ctx.stop = this._input.LT(-1);
			this.state = 254;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 17, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = localctx;
					{
					this.state = 252;
					this._errHandler.sync(this);
					switch ( this._interp.adaptivePredict(this._input, 16, this._ctx) ) {
					case 1:
						{
						localctx = new TupleTypeContext(this, new TypeContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_type);
						this.state = 243;
						if (!(this.precpred(this._ctx, 5))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 5)");
						}
						this.state = 244;
						this.match(LambdaCalcParser.T__8);
						this.state = 245;
						this.type_(5);
						}
						break;
					case 2:
						{
						localctx = new BinaryVariantTypeContext(this, new TypeContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_type);
						this.state = 246;
						if (!(this.precpred(this._ctx, 4))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 4)");
						}
						this.state = 247;
						this.match(LambdaCalcParser.T__6);
						this.state = 248;
						this.type_(5);
						}
						break;
					case 3:
						{
						localctx = new FunctionTypeContext(this, new TypeContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, LambdaCalcParser.RULE_type);
						this.state = 249;
						if (!(this.precpred(this._ctx, 2))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 2)");
						}
						this.state = 250;
						this.match(LambdaCalcParser.ARROW);
						this.state = 251;
						this.type_(2);
						}
						break;
					}
					}
				}
				this.state = 256;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 17, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return localctx;
	}
	// @RuleVersion(0)
	public list_op(): List_opContext {
		let localctx: List_opContext = new List_opContext(this, this._ctx, this.state);
		this.enterRule(localctx, 10, LambdaCalcParser.RULE_list_op);
		let _la: number;
		try {
			this.state = 293;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 35:
				localctx = new ListNilContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 257;
				this.match(LambdaCalcParser.NIL);
				this.state = 258;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 259;
				this.type_(0);
				this.state = 260;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			case 36:
				localctx = new ListConsContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 262;
				this.match(LambdaCalcParser.CONS);
				this.state = 263;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 264;
				this.type_(0);
				this.state = 265;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			case 37:
				localctx = new ListIsNilContext(this, localctx);
				this.enterOuterAlt(localctx, 3);
				{
				this.state = 267;
				this.match(LambdaCalcParser.ISNIL);
				this.state = 268;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 269;
				this.type_(0);
				this.state = 270;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			case 38:
				localctx = new ListTailContext(this, localctx);
				this.enterOuterAlt(localctx, 4);
				{
				this.state = 272;
				this.match(LambdaCalcParser.TAIL);
				this.state = 273;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 274;
				this.type_(0);
				this.state = 275;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			case 39:
				localctx = new ListHeadContext(this, localctx);
				this.enterOuterAlt(localctx, 5);
				{
				this.state = 277;
				this.match(LambdaCalcParser.HEAD);
				this.state = 278;
				this.match(LambdaCalcParser.LBRACK);
				this.state = 279;
				this.type_(0);
				this.state = 280;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			case 40:
				localctx = new ListConstructorContext(this, localctx);
				this.enterOuterAlt(localctx, 6);
				{
				this.state = 282;
				this.match(LambdaCalcParser.LBRACK);
				{
				this.state = 283;
				this.term(0);
				this.state = 288;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				while (_la===45) {
					{
					{
					this.state = 284;
					this.match(LambdaCalcParser.COMMA);
					this.state = 285;
					this.term(0);
					}
					}
					this.state = 290;
					this._errHandler.sync(this);
					_la = this._input.LA(1);
				}
				}
				this.state = 291;
				this.match(LambdaCalcParser.RBRACK);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public constant(): ConstantContext {
		let localctx: ConstantContext = new ConstantContext(this, this._ctx, this.state);
		this.enterRule(localctx, 12, LambdaCalcParser.RULE_constant);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 295;
			_la = this._input.LA(1);
			if(!(((((_la - 25)) & ~0x1F) === 0 && ((1 << (_la - 25)) & 524541) !== 0))) {
			this._errHandler.recoverInline(this);
			}
			else {
				this._errHandler.reportMatch(this);
			    this.consume();
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public sempred(localctx: RuleContext, ruleIndex: number, predIndex: number): boolean {
		switch (ruleIndex) {
		case 3:
			return this.term_sempred(localctx as TermContext, predIndex);
		case 4:
			return this.type_sempred(localctx as TypeContext, predIndex);
		}
		return true;
	}
	private term_sempred(localctx: TermContext, predIndex: number): boolean {
		switch (predIndex) {
		case 0:
			return this.precpred(this._ctx, 21);
		case 1:
			return this.precpred(this._ctx, 20);
		case 2:
			return this.precpred(this._ctx, 19);
		case 3:
			return this.precpred(this._ctx, 18);
		case 4:
			return this.precpred(this._ctx, 17);
		case 5:
			return this.precpred(this._ctx, 6);
		case 6:
			return this.precpred(this._ctx, 5);
		}
		return true;
	}
	private type_sempred(localctx: TypeContext, predIndex: number): boolean {
		switch (predIndex) {
		case 7:
			return this.precpred(this._ctx, 5);
		case 8:
			return this.precpred(this._ctx, 4);
		case 9:
			return this.precpred(this._ctx, 2);
		}
		return true;
	}

	public static readonly _serializedATN: number[] = [4,1,54,298,2,0,7,0,2,
	1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,6,1,0,5,0,16,8,0,10,0,12,0,
	19,9,0,1,0,1,0,1,0,1,1,1,1,1,1,5,1,27,8,1,10,1,12,1,30,9,1,1,1,1,1,1,1,
	1,1,3,1,36,8,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
	1,2,1,2,3,2,54,8,2,1,2,1,2,3,2,58,8,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
	3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,5,3,84,8,
	3,10,3,12,3,87,9,3,1,3,1,3,3,3,91,8,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
	3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,5,3,118,
	8,3,10,3,12,3,121,9,3,1,3,1,3,1,3,1,3,1,3,1,3,5,3,129,8,3,10,3,12,3,132,
	9,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
	1,3,1,3,1,3,1,3,5,3,155,8,3,10,3,12,3,158,9,3,1,3,1,3,1,3,1,3,1,3,1,3,1,
	3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,3,3,177,8,3,1,3,1,3,1,3,1,3,1,
	3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,5,3,199,8,
	3,10,3,12,3,202,9,3,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,5,4,
	216,8,4,10,4,12,4,219,9,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,5,4,231,
	8,4,10,4,12,4,234,9,4,1,4,1,4,1,4,1,4,1,4,1,4,3,4,242,8,4,1,4,1,4,1,4,1,
	4,1,4,1,4,1,4,1,4,1,4,5,4,253,8,4,10,4,12,4,256,9,4,1,5,1,5,1,5,1,5,1,5,
	1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
	1,5,1,5,1,5,1,5,1,5,1,5,5,5,287,8,5,10,5,12,5,290,9,5,1,5,1,5,3,5,294,8,
	5,1,6,1,6,1,6,0,2,6,8,7,0,2,4,6,8,10,12,0,5,1,0,18,19,1,0,2,6,1,0,7,8,2,
	0,23,25,42,43,3,0,25,25,27,32,44,44,336,0,17,1,0,0,0,2,28,1,0,0,0,4,57,
	1,0,0,0,6,176,1,0,0,0,8,241,1,0,0,0,10,293,1,0,0,0,12,295,1,0,0,0,14,16,
	3,4,2,0,15,14,1,0,0,0,16,19,1,0,0,0,17,15,1,0,0,0,17,18,1,0,0,0,18,20,1,
	0,0,0,19,17,1,0,0,0,20,21,3,2,1,0,21,22,5,0,0,1,22,1,1,0,0,0,23,24,3,6,
	3,0,24,25,5,50,0,0,25,27,1,0,0,0,26,23,1,0,0,0,27,30,1,0,0,0,28,26,1,0,
	0,0,28,29,1,0,0,0,29,31,1,0,0,0,30,28,1,0,0,0,31,32,3,6,3,0,32,33,5,48,
	0,0,33,35,3,8,4,0,34,36,5,50,0,0,35,34,1,0,0,0,35,36,1,0,0,0,36,3,1,0,0,
	0,37,38,5,1,0,0,38,39,5,42,0,0,39,40,5,34,0,0,40,41,3,8,4,0,41,42,5,50,
	0,0,42,58,1,0,0,0,43,44,5,42,0,0,44,45,5,48,0,0,45,46,3,8,4,0,46,47,5,50,
	0,0,47,58,1,0,0,0,48,49,5,42,0,0,49,50,5,34,0,0,50,53,3,6,3,0,51,52,5,48,
	0,0,52,54,3,8,4,0,53,51,1,0,0,0,53,54,1,0,0,0,54,55,1,0,0,0,55,56,5,50,
	0,0,56,58,1,0,0,0,57,37,1,0,0,0,57,43,1,0,0,0,57,48,1,0,0,0,58,5,1,0,0,
	0,59,60,6,3,-1,0,60,61,5,33,0,0,61,62,5,42,0,0,62,63,5,48,0,0,63,64,3,8,
	4,0,64,65,5,49,0,0,65,66,3,6,3,16,66,177,1,0,0,0,67,68,5,33,0,0,68,69,5,
	11,0,0,69,70,5,48,0,0,70,71,3,8,4,0,71,72,5,49,0,0,72,73,3,6,3,15,73,177,
	1,0,0,0,74,75,5,12,0,0,75,76,3,6,3,0,76,77,5,13,0,0,77,85,3,6,3,0,78,79,
	5,14,0,0,79,80,3,6,3,0,80,81,5,13,0,0,81,82,3,6,3,0,82,84,1,0,0,0,83,78,
	1,0,0,0,84,87,1,0,0,0,85,83,1,0,0,0,85,86,1,0,0,0,86,90,1,0,0,0,87,85,1,
	0,0,0,88,89,5,15,0,0,89,91,3,6,3,0,90,88,1,0,0,0,90,91,1,0,0,0,91,177,1,
	0,0,0,92,177,5,42,0,0,93,94,5,16,0,0,94,177,3,6,3,12,95,177,3,12,6,0,96,
	97,5,40,0,0,97,98,5,42,0,0,98,99,5,34,0,0,99,100,3,6,3,0,100,101,5,41,0,
	0,101,102,5,17,0,0,102,103,3,8,4,0,103,177,1,0,0,0,104,105,7,0,0,0,105,
	106,3,6,3,0,106,107,5,17,0,0,107,108,3,8,4,0,108,177,1,0,0,0,109,110,5,
	4,0,0,110,111,5,42,0,0,111,112,5,34,0,0,112,119,3,6,3,0,113,114,5,45,0,
	0,114,115,5,42,0,0,115,116,5,34,0,0,116,118,3,6,3,0,117,113,1,0,0,0,118,
	121,1,0,0,0,119,117,1,0,0,0,119,120,1,0,0,0,120,122,1,0,0,0,121,119,1,0,
	0,0,122,123,5,2,0,0,123,177,1,0,0,0,124,125,5,4,0,0,125,130,3,6,3,0,126,
	127,5,45,0,0,127,129,3,6,3,0,128,126,1,0,0,0,129,132,1,0,0,0,130,128,1,
	0,0,0,130,131,1,0,0,0,131,133,1,0,0,0,132,130,1,0,0,0,133,134,5,2,0,0,134,
	177,1,0,0,0,135,177,3,10,5,0,136,137,5,20,0,0,137,138,3,6,3,0,138,139,5,
	21,0,0,139,140,5,40,0,0,140,141,5,42,0,0,141,142,5,34,0,0,142,143,5,42,
	0,0,143,144,5,41,0,0,144,145,5,47,0,0,145,156,3,6,3,0,146,147,5,22,0,0,
	147,148,5,40,0,0,148,149,5,42,0,0,149,150,5,34,0,0,150,151,5,42,0,0,151,
	152,5,41,0,0,152,153,5,47,0,0,153,155,3,6,3,0,154,146,1,0,0,0,155,158,1,
	0,0,0,156,154,1,0,0,0,156,157,1,0,0,0,157,177,1,0,0,0,158,156,1,0,0,0,159,
	160,5,20,0,0,160,161,3,6,3,0,161,162,5,21,0,0,162,163,7,0,0,0,163,164,5,
	42,0,0,164,165,5,47,0,0,165,166,3,6,3,0,166,167,5,22,0,0,167,168,7,0,0,
	0,168,169,5,42,0,0,169,170,5,47,0,0,170,171,3,6,3,2,171,177,1,0,0,0,172,
	173,5,51,0,0,173,174,3,6,3,0,174,175,5,52,0,0,175,177,1,0,0,0,176,59,1,
	0,0,0,176,67,1,0,0,0,176,74,1,0,0,0,176,92,1,0,0,0,176,93,1,0,0,0,176,95,
	1,0,0,0,176,96,1,0,0,0,176,104,1,0,0,0,176,109,1,0,0,0,176,124,1,0,0,0,
	176,135,1,0,0,0,176,136,1,0,0,0,176,159,1,0,0,0,176,172,1,0,0,0,177,200,
	1,0,0,0,178,179,10,21,0,0,179,199,3,6,3,22,180,181,10,20,0,0,181,182,7,
	1,0,0,182,199,3,6,3,21,183,184,10,19,0,0,184,185,7,2,0,0,185,199,3,6,3,
	20,186,187,10,18,0,0,187,188,5,9,0,0,188,199,3,6,3,19,189,190,10,17,0,0,
	190,191,5,10,0,0,191,199,3,6,3,18,192,193,10,6,0,0,193,194,5,49,0,0,194,
	199,5,42,0,0,195,196,10,5,0,0,196,197,5,49,0,0,197,199,5,44,0,0,198,178,
	1,0,0,0,198,180,1,0,0,0,198,183,1,0,0,0,198,186,1,0,0,0,198,189,1,0,0,0,
	198,192,1,0,0,0,198,195,1,0,0,0,199,202,1,0,0,0,200,198,1,0,0,0,200,201,
	1,0,0,0,201,7,1,0,0,0,202,200,1,0,0,0,203,204,6,4,-1,0,204,242,7,3,0,0,
	205,206,5,26,0,0,206,242,3,8,4,7,207,208,5,4,0,0,208,209,5,42,0,0,209,210,
	5,48,0,0,210,217,3,8,4,0,211,212,5,45,0,0,212,213,5,42,0,0,213,214,5,48,
	0,0,214,216,3,8,4,0,215,211,1,0,0,0,216,219,1,0,0,0,217,215,1,0,0,0,217,
	218,1,0,0,0,218,220,1,0,0,0,219,217,1,0,0,0,220,221,5,2,0,0,221,242,1,0,
	0,0,222,223,5,40,0,0,223,224,5,42,0,0,224,225,5,48,0,0,225,232,3,8,4,0,
	226,227,5,45,0,0,227,228,5,42,0,0,228,229,5,48,0,0,229,231,3,8,4,0,230,
	226,1,0,0,0,231,234,1,0,0,0,232,230,1,0,0,0,232,233,1,0,0,0,233,235,1,0,
	0,0,234,232,1,0,0,0,235,236,5,41,0,0,236,242,1,0,0,0,237,238,5,51,0,0,238,
	239,3,8,4,0,239,240,5,52,0,0,240,242,1,0,0,0,241,203,1,0,0,0,241,205,1,
	0,0,0,241,207,1,0,0,0,241,222,1,0,0,0,241,237,1,0,0,0,242,254,1,0,0,0,243,
	244,10,5,0,0,244,245,5,9,0,0,245,253,3,8,4,5,246,247,10,4,0,0,247,248,5,
	7,0,0,248,253,3,8,4,5,249,250,10,2,0,0,250,251,5,46,0,0,251,253,3,8,4,2,
	252,243,1,0,0,0,252,246,1,0,0,0,252,249,1,0,0,0,253,256,1,0,0,0,254,252,
	1,0,0,0,254,255,1,0,0,0,255,9,1,0,0,0,256,254,1,0,0,0,257,258,5,35,0,0,
	258,259,5,40,0,0,259,260,3,8,4,0,260,261,5,41,0,0,261,294,1,0,0,0,262,263,
	5,36,0,0,263,264,5,40,0,0,264,265,3,8,4,0,265,266,5,41,0,0,266,294,1,0,
	0,0,267,268,5,37,0,0,268,269,5,40,0,0,269,270,3,8,4,0,270,271,5,41,0,0,
	271,294,1,0,0,0,272,273,5,38,0,0,273,274,5,40,0,0,274,275,3,8,4,0,275,276,
	5,41,0,0,276,294,1,0,0,0,277,278,5,39,0,0,278,279,5,40,0,0,279,280,3,8,
	4,0,280,281,5,41,0,0,281,294,1,0,0,0,282,283,5,40,0,0,283,288,3,6,3,0,284,
	285,5,45,0,0,285,287,3,6,3,0,286,284,1,0,0,0,287,290,1,0,0,0,288,286,1,
	0,0,0,288,289,1,0,0,0,289,291,1,0,0,0,290,288,1,0,0,0,291,292,5,41,0,0,
	292,294,1,0,0,0,293,257,1,0,0,0,293,262,1,0,0,0,293,267,1,0,0,0,293,272,
	1,0,0,0,293,277,1,0,0,0,293,282,1,0,0,0,294,11,1,0,0,0,295,296,7,4,0,0,
	296,13,1,0,0,0,20,17,28,35,53,57,85,90,119,130,156,176,198,200,217,232,
	241,252,254,288,293];

	private static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!LambdaCalcParser.__ATN) {
			LambdaCalcParser.__ATN = new ATNDeserializer().deserialize(LambdaCalcParser._serializedATN);
		}

		return LambdaCalcParser.__ATN;
	}


	static DecisionsToDFA = LambdaCalcParser._ATN.decisionToState.map( (ds: DecisionState, index: number) => new DFA(ds, index) );

}

export class ExpressionContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_expression;
	}
	public override copyFrom(ctx: ExpressionContext): void {
		super.copyFrom(ctx);
	}
}
export class ExprContext extends ExpressionContext {
	constructor(parser: LambdaCalcParser, ctx: ExpressionContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public terms(): TermsContext {
		return this.getTypedRuleContext(TermsContext, 0) as TermsContext;
	}
	public EOF(): TerminalNode {
		return this.getToken(LambdaCalcParser.EOF, 0);
	}
	public globalDecl_list(): GlobalDeclContext[] {
		return this.getTypedRuleContexts(GlobalDeclContext) as GlobalDeclContext[];
	}
	public globalDecl(i: number): GlobalDeclContext {
		return this.getTypedRuleContext(GlobalDeclContext, i) as GlobalDeclContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterExpr) {
	 		listener.enterExpr(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitExpr) {
	 		listener.exitExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitExpr) {
			return visitor.visitExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class TermsContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_terms;
	}
	public override copyFrom(ctx: TermsContext): void {
		super.copyFrom(ctx);
	}
}
export class SequenceContext extends TermsContext {
	public _seqTerm!: TermContext;
	constructor(parser: LambdaCalcParser, ctx: TermsContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public COLON(): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public SEMI_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.SEMI);
	}
	public SEMI(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.SEMI, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterSequence) {
	 		listener.enterSequence(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitSequence) {
	 		listener.exitSequence(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitSequence) {
			return visitor.visitSequence(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class GlobalDeclContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_globalDecl;
	}
	public override copyFrom(ctx: GlobalDeclContext): void {
		super.copyFrom(ctx);
	}
}
export class GlobalFunctionDeclarationContext extends GlobalDeclContext {
	constructor(parser: LambdaCalcParser, ctx: GlobalDeclContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public EQ(): TerminalNode {
		return this.getToken(LambdaCalcParser.EQ, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public SEMI(): TerminalNode {
		return this.getToken(LambdaCalcParser.SEMI, 0);
	}
	public COLON(): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterGlobalFunctionDeclaration) {
	 		listener.enterGlobalFunctionDeclaration(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitGlobalFunctionDeclaration) {
	 		listener.exitGlobalFunctionDeclaration(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitGlobalFunctionDeclaration) {
			return visitor.visitGlobalFunctionDeclaration(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class TypeAliasContext extends GlobalDeclContext {
	constructor(parser: LambdaCalcParser, ctx: GlobalDeclContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public EQ(): TerminalNode {
		return this.getToken(LambdaCalcParser.EQ, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public SEMI(): TerminalNode {
		return this.getToken(LambdaCalcParser.SEMI, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterTypeAlias) {
	 		listener.enterTypeAlias(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitTypeAlias) {
	 		listener.exitTypeAlias(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitTypeAlias) {
			return visitor.visitTypeAlias(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class GlobalVariableDeclarationContext extends GlobalDeclContext {
	constructor(parser: LambdaCalcParser, ctx: GlobalDeclContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public COLON(): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public SEMI(): TerminalNode {
		return this.getToken(LambdaCalcParser.SEMI, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterGlobalVariableDeclaration) {
	 		listener.enterGlobalVariableDeclaration(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitGlobalVariableDeclaration) {
	 		listener.exitGlobalVariableDeclaration(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitGlobalVariableDeclaration) {
			return visitor.visitGlobalVariableDeclaration(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class TermContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_term;
	}
	public override copyFrom(ctx: TermContext): void {
		super.copyFrom(ctx);
	}
}
export class AdditionContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterAddition) {
	 		listener.enterAddition(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitAddition) {
	 		listener.exitAddition(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitAddition) {
			return visitor.visitAddition(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class MultiplicationContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterMultiplication) {
	 		listener.enterMultiplication(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitMultiplication) {
	 		listener.exitMultiplication(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitMultiplication) {
			return visitor.visitMultiplication(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class VariableContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterVariable) {
	 		listener.enterVariable(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitVariable) {
	 		listener.exitVariable(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitVariable) {
			return visitor.visitVariable(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class IfElseContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterIfElse) {
	 		listener.enterIfElse(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitIfElse) {
	 		listener.exitIfElse(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitIfElse) {
			return visitor.visitIfElse(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class CaseOfContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public LBRACK_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.LBRACK);
	}
	public LBRACK(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, i);
	}
	public ID_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.ID);
	}
	public ID(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, i);
	}
	public EQ_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.EQ);
	}
	public EQ(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.EQ, i);
	}
	public RBRACK_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.RBRACK);
	}
	public RBRACK(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, i);
	}
	public DOUBLEARROW_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.DOUBLEARROW);
	}
	public DOUBLEARROW(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.DOUBLEARROW, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterCaseOf) {
	 		listener.enterCaseOf(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitCaseOf) {
	 		listener.exitCaseOf(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitCaseOf) {
			return visitor.visitCaseOf(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class InjectionContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public EQ(): TerminalNode {
		return this.getToken(LambdaCalcParser.EQ, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterInjection) {
	 		listener.enterInjection(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitInjection) {
	 		listener.exitInjection(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitInjection) {
			return visitor.visitInjection(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class LeftRightInjContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterLeftRightInj) {
	 		listener.enterLeftRightInj(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitLeftRightInj) {
	 		listener.exitLeftRightInj(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitLeftRightInj) {
			return visitor.visitLeftRightInj(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class LambdaAbstractionContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LAMBDA(): TerminalNode {
		return this.getToken(LambdaCalcParser.LAMBDA, 0);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public COLON(): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public DOT(): TerminalNode {
		return this.getToken(LambdaCalcParser.DOT, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterLambdaAbstraction) {
	 		listener.enterLambdaAbstraction(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitLambdaAbstraction) {
	 		listener.exitLambdaAbstraction(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitLambdaAbstraction) {
			return visitor.visitLambdaAbstraction(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class FixContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterFix) {
	 		listener.enterFix(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitFix) {
	 		listener.exitFix(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitFix) {
			return visitor.visitFix(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ComparisonContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterComparison) {
	 		listener.enterComparison(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitComparison) {
	 		listener.exitComparison(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitComparison) {
			return visitor.visitComparison(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class RecordProjectionContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public DOT(): TerminalNode {
		return this.getToken(LambdaCalcParser.DOT, 0);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterRecordProjection) {
	 		listener.enterRecordProjection(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitRecordProjection) {
	 		listener.exitRecordProjection(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitRecordProjection) {
			return visitor.visitRecordProjection(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class TupleProjectionContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public DOT(): TerminalNode {
		return this.getToken(LambdaCalcParser.DOT, 0);
	}
	public NATURAL_NUMBER(): TerminalNode {
		return this.getToken(LambdaCalcParser.NATURAL_NUMBER, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterTupleProjection) {
	 		listener.enterTupleProjection(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitTupleProjection) {
	 		listener.exitTupleProjection(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitTupleProjection) {
			return visitor.visitTupleProjection(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class LiteralContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public constant(): ConstantContext {
		return this.getTypedRuleContext(ConstantContext, 0) as ConstantContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterLiteral) {
	 		listener.enterLiteral(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitLiteral) {
	 		listener.exitLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitLiteral) {
			return visitor.visitLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class BinaryCaseOfContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public ID_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.ID);
	}
	public ID(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, i);
	}
	public DOUBLEARROW_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.DOUBLEARROW);
	}
	public DOUBLEARROW(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.DOUBLEARROW, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterBinaryCaseOf) {
	 		listener.enterBinaryCaseOf(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitBinaryCaseOf) {
	 		listener.exitBinaryCaseOf(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitBinaryCaseOf) {
			return visitor.visitBinaryCaseOf(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class RecordContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ID_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.ID);
	}
	public ID(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, i);
	}
	public EQ_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.EQ);
	}
	public EQ(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.EQ, i);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public COMMA_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COMMA);
	}
	public COMMA(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COMMA, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterRecord) {
	 		listener.enterRecord(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitRecord) {
	 		listener.exitRecord(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitRecord) {
			return visitor.visitRecord(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public list_op(): List_opContext {
		return this.getTypedRuleContext(List_opContext, 0) as List_opContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterList) {
	 		listener.enterList(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitList) {
	 		listener.exitList(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitList) {
			return visitor.visitList(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class WildCardContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LAMBDA(): TerminalNode {
		return this.getToken(LambdaCalcParser.LAMBDA, 0);
	}
	public COLON(): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public DOT(): TerminalNode {
		return this.getToken(LambdaCalcParser.DOT, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterWildCard) {
	 		listener.enterWildCard(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitWildCard) {
	 		listener.exitWildCard(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitWildCard) {
			return visitor.visitWildCard(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ApplicationContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterApplication) {
	 		listener.enterApplication(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitApplication) {
	 		listener.exitApplication(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitApplication) {
			return visitor.visitApplication(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class TupleContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public COMMA_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COMMA);
	}
	public COMMA(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COMMA, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterTuple) {
	 		listener.enterTuple(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitTuple) {
	 		listener.exitTuple(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitTuple) {
			return visitor.visitTuple(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ParenthesesContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LPAREN(): TerminalNode {
		return this.getToken(LambdaCalcParser.LPAREN, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public RPAREN(): TerminalNode {
		return this.getToken(LambdaCalcParser.RPAREN, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterParentheses) {
	 		listener.enterParentheses(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitParentheses) {
	 		listener.exitParentheses(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitParentheses) {
			return visitor.visitParentheses(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class PowerContext extends TermContext {
	constructor(parser: LambdaCalcParser, ctx: TermContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterPower) {
	 		listener.enterPower(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitPower) {
	 		listener.exitPower(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitPower) {
			return visitor.visitPower(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class TypeContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_type;
	}
	public override copyFrom(ctx: TypeContext): void {
		super.copyFrom(ctx);
	}
}
export class GreekTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public GREEK_TYPE(): TerminalNode {
		return this.getToken(LambdaCalcParser.GREEK_TYPE, 0);
	}
	public ID(): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterGreekType) {
	 		listener.enterGreekType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitGreekType) {
	 		listener.exitGreekType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitGreekType) {
			return visitor.visitGreekType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class RecordTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ID_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.ID);
	}
	public ID(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, i);
	}
	public COLON_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COLON);
	}
	public COLON(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, i);
	}
	public type__list(): TypeContext[] {
		return this.getTypedRuleContexts(TypeContext) as TypeContext[];
	}
	public type_(i: number): TypeContext {
		return this.getTypedRuleContext(TypeContext, i) as TypeContext;
	}
	public COMMA_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COMMA);
	}
	public COMMA(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COMMA, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterRecordType) {
	 		listener.enterRecordType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitRecordType) {
	 		listener.exitRecordType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitRecordType) {
			return visitor.visitRecordType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListType) {
	 		listener.enterListType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListType) {
	 		listener.exitListType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListType) {
			return visitor.visitListType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class VariantTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public ID_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.ID);
	}
	public ID(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.ID, i);
	}
	public COLON_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COLON);
	}
	public COLON(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COLON, i);
	}
	public type__list(): TypeContext[] {
		return this.getTypedRuleContexts(TypeContext) as TypeContext[];
	}
	public type_(i: number): TypeContext {
		return this.getTypedRuleContext(TypeContext, i) as TypeContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public COMMA_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COMMA);
	}
	public COMMA(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COMMA, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterVariantType) {
	 		listener.enterVariantType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitVariantType) {
	 		listener.exitVariantType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitVariantType) {
			return visitor.visitVariantType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class BinaryVariantTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public type__list(): TypeContext[] {
		return this.getTypedRuleContexts(TypeContext) as TypeContext[];
	}
	public type_(i: number): TypeContext {
		return this.getTypedRuleContext(TypeContext, i) as TypeContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterBinaryVariantType) {
	 		listener.enterBinaryVariantType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitBinaryVariantType) {
	 		listener.exitBinaryVariantType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitBinaryVariantType) {
			return visitor.visitBinaryVariantType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class FunctionTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public type__list(): TypeContext[] {
		return this.getTypedRuleContexts(TypeContext) as TypeContext[];
	}
	public type_(i: number): TypeContext {
		return this.getTypedRuleContext(TypeContext, i) as TypeContext;
	}
	public ARROW(): TerminalNode {
		return this.getToken(LambdaCalcParser.ARROW, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterFunctionType) {
	 		listener.enterFunctionType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitFunctionType) {
	 		listener.exitFunctionType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitFunctionType) {
			return visitor.visitFunctionType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class TupleTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public type__list(): TypeContext[] {
		return this.getTypedRuleContexts(TypeContext) as TypeContext[];
	}
	public type_(i: number): TypeContext {
		return this.getTypedRuleContext(TypeContext, i) as TypeContext;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterTupleType) {
	 		listener.enterTupleType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitTupleType) {
	 		listener.exitTupleType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitTupleType) {
			return visitor.visitTupleType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ParenTypeContext extends TypeContext {
	constructor(parser: LambdaCalcParser, ctx: TypeContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LPAREN(): TerminalNode {
		return this.getToken(LambdaCalcParser.LPAREN, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public RPAREN(): TerminalNode {
		return this.getToken(LambdaCalcParser.RPAREN, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterParenType) {
	 		listener.enterParenType(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitParenType) {
	 		listener.exitParenType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitParenType) {
			return visitor.visitParenType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class List_opContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_list_op;
	}
	public override copyFrom(ctx: List_opContext): void {
		super.copyFrom(ctx);
	}
}
export class ListTailContext extends List_opContext {
	constructor(parser: LambdaCalcParser, ctx: List_opContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public TAIL(): TerminalNode {
		return this.getToken(LambdaCalcParser.TAIL, 0);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListTail) {
	 		listener.enterListTail(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListTail) {
	 		listener.exitListTail(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListTail) {
			return visitor.visitListTail(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListNilContext extends List_opContext {
	constructor(parser: LambdaCalcParser, ctx: List_opContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public NIL(): TerminalNode {
		return this.getToken(LambdaCalcParser.NIL, 0);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListNil) {
	 		listener.enterListNil(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListNil) {
	 		listener.exitListNil(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListNil) {
			return visitor.visitListNil(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListHeadContext extends List_opContext {
	constructor(parser: LambdaCalcParser, ctx: List_opContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public HEAD(): TerminalNode {
		return this.getToken(LambdaCalcParser.HEAD, 0);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListHead) {
	 		listener.enterListHead(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListHead) {
	 		listener.exitListHead(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListHead) {
			return visitor.visitListHead(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListConsContext extends List_opContext {
	constructor(parser: LambdaCalcParser, ctx: List_opContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public CONS(): TerminalNode {
		return this.getToken(LambdaCalcParser.CONS, 0);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListCons) {
	 		listener.enterListCons(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListCons) {
	 		listener.exitListCons(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListCons) {
			return visitor.visitListCons(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListIsNilContext extends List_opContext {
	constructor(parser: LambdaCalcParser, ctx: List_opContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ISNIL(): TerminalNode {
		return this.getToken(LambdaCalcParser.ISNIL, 0);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public type_(): TypeContext {
		return this.getTypedRuleContext(TypeContext, 0) as TypeContext;
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListIsNil) {
	 		listener.enterListIsNil(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListIsNil) {
	 		listener.exitListIsNil(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListIsNil) {
			return visitor.visitListIsNil(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListConstructorContext extends List_opContext {
	constructor(parser: LambdaCalcParser, ctx: List_opContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public LBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.LBRACK, 0);
	}
	public RBRACK(): TerminalNode {
		return this.getToken(LambdaCalcParser.RBRACK, 0);
	}
	public term_list(): TermContext[] {
		return this.getTypedRuleContexts(TermContext) as TermContext[];
	}
	public term(i: number): TermContext {
		return this.getTypedRuleContext(TermContext, i) as TermContext;
	}
	public COMMA_list(): TerminalNode[] {
	    	return this.getTokens(LambdaCalcParser.COMMA);
	}
	public COMMA(i: number): TerminalNode {
		return this.getToken(LambdaCalcParser.COMMA, i);
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterListConstructor) {
	 		listener.enterListConstructor(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitListConstructor) {
	 		listener.exitListConstructor(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitListConstructor) {
			return visitor.visitListConstructor(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ConstantContext extends ParserRuleContext {
	constructor(parser?: LambdaCalcParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public NATURAL_NUMBER(): TerminalNode {
		return this.getToken(LambdaCalcParser.NATURAL_NUMBER, 0);
	}
    public get ruleIndex(): number {
    	return LambdaCalcParser.RULE_constant;
	}
	public enterRule(listener: LambdaCalcListener): void {
	    if(listener.enterConstant) {
	 		listener.enterConstant(this);
		}
	}
	public exitRule(listener: LambdaCalcListener): void {
	    if(listener.exitConstant) {
	 		listener.exitConstant(this);
		}
	}
	// @Override
	public accept<Result>(visitor: LambdaCalcVisitor<Result>): Result {
		if (visitor.visitConstant) {
			return visitor.visitConstant(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
